export default __webpack_public_path__ + "static/media/Contact-Info.786c75ad.jpg";